module.exports = __webpack_public_path__ + "img/CA.6cafa17d.svg";